import type { NavItem } from "@/lib/permissions";

/** Sidebar tree for in-app docs; paths must match `documentationSources` keys. */
export function documentationSidebarRoot(requiredRole: NavItem["requiredRole"]): NavItem {
  return {
    id: "documentation",
    label: "Documentation",
    icon: "BookOpen",
    requiredRole,
    submenu: [
      {
        id: "documentation-home",
        label: "Documentation home",
        icon: "BookOpen",
        path: "/documentation",
        exact: true,
      },
      {
        id: "documentation-acquisitions",
        label: "Acquisitions",
        icon: "Package",
        submenu: [
          {
            id: "documentation-acquisition-overview",
            label: "Overview",
            icon: "LayoutList",
            path: "/documentation/acquisition",
            exact: true,
          },
          {
            id: "documentation-acquisition-admin",
            label: "Administrators",
            icon: "Shield",
            path: "/documentation/acquisition/admin",
          },
          {
            id: "documentation-acquisition-staff",
            label: "Staff",
            icon: "Users",
            path: "/documentation/acquisition/staff",
          },
          {
            id: "documentation-acquisition-patron",
            label: "Patrons",
            icon: "UserCircle",
            path: "/documentation/acquisition/patron",
          },
        ],
      },
      {
        id: "documentation-catalog",
        label: "Catalog module",
        icon: "Library",
        path: "/documentation/catalog",
      },
      {
        id: "documentation-circulation",
        label: "Circulation module",
        icon: "RefreshCw",
        path: "/documentation/circulation",
      },
      {
        id: "documentation-public-opac",
        label: "Public OPAC API",
        icon: "KeyRound",
        path: "/documentation/public-opac",
        requiredRole: ["TENANT_ADMIN", "LIBRARIAN", "STAFF"],
      },
    ],
  };
}
